'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var qwest = _interopRequireWildcard(require("qwest"));
var _moment = _interopRequireDefault(require("moment"));
var _Link = _interopRequireDefault(require("Pure/Link"));
var _Loader = _interopRequireDefault(require("Pure/Loader"));
var _getFormStatus = _interopRequireDefault(require("Components/Forms/Functions/getFormStatus"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
_moment.default.locale('fr');
let app = window.app;
class CandidateListDetails extends _react.Component {
  state = {
    loading: false,
    cv_id: document.location.pathname.split('/candidats/')[1],
    current_info: 0,
    status_messages: {}
  };
  componentDidMount() {
    const component = this,
      props = this.props,
      state = this.state;
    const company_id = app.state?.session?.user?.id;
    component.setState({
      company_id: company_id
    });
    component.fetchCandidateAndCV(company_id);
  }
  fetchCandidateAndCV = company_id => {
    const component = this,
      props = this.props,
      state = this.state;
    component.setState({
      loading: true
    });
    qwest.post('/cv/get-all-with-candidate', {
      company_id: company_id,
      cv_id: state.cv_id
    }).then(function (xhr, response) {
      component.setState({
        loading: false,
        cv: response.cvs[0]
      });
    }).catch(function (error, xhr, response) {
      console.error(response?.error || response?.raw || error);
      component.setState({
        ...getErrorsFromResponse({
          response: response
        })
      });
    });
  };
  getSearchedContractLabel = searched_contracts => {
    if (!searched_contracts) return;
    let searched_contracts_label = (Object.keys(searched_contracts) || []).map(function (searched_contract) {
      let label;
      if (searched_contract === "alternance" && searched_contracts[searched_contract] === true) {
        label = "Alternance";
      } else if (searched_contract === "cdd" && searched_contracts[searched_contract] === true) {
        label = "CDD";
      } else if (searched_contract === "cdi" && searched_contracts[searched_contract] === true) {
        label = "CDI";
      } else if (searched_contract === "stage" && searched_contracts[searched_contract] === true) {
        label = "Stage";
      }
      return label + ' ';
    });
    return searched_contracts_label;
  };
  sendInterestNotif = () => {
    const component = this,
      props = this.props,
      state = this.state;
    qwest.post('/candidate/company-interest', {
      company_id: state.company_id,
      candidate_id: state.cv._candidate.id
    }).then(function (xhr, response) {
      component.setState({
        loading: false,
        info: response.info
      });
    }).catch(function (error, xhr, response) {
      console.error(response?.error || response?.raw || error);
      component.setState({
        ...getErrorsFromResponse({
          response: response
        })
      });
    });
  };
  render() {
    const component = this,
      props = this.props,
      state = this.state;
    const loader = state.loading === true ? /*#__PURE__*/_react.default.createElement(_Loader.default, {
      className: "c-loader",
      bemit: ['white', 'bg-carbon']
    }) : undefined;
    let formation_list = (state?.cv?.formation || []).map(function (formation) {
      let output = /*#__PURE__*/_react.default.createElement("div", {
        className: "c-formation-card",
        key: formation.id
      }, /*#__PURE__*/_react.default.createElement("h3", {
        className: "c-formation-card__title"
      }, formation.title, formation.start_date ? " - " + (0, _moment.default)(formation.start_date).format('DD/MM/YYYY') : "", formation.end_date ? ' - ' + (0, _moment.default)(formation.end_date).format('DD/MM/YYYY') : ""), /*#__PURE__*/_react.default.createElement("div", {
        className: "c-formation-card__description",
        dangerouslySetInnerHTML: {
          __html: formation.description
        }
      }));
      return output;
    });
    let experience_list = (state?.cv?.experience || []).map(function (experience) {
      let output = /*#__PURE__*/_react.default.createElement("div", {
        className: "c-experience-card",
        key: experience.id
      }, /*#__PURE__*/_react.default.createElement("h3", {
        className: "c-experience-card__title"
      }, experience.title, experience.company ? " (" + experience.company + ") " : undefined, experience.start_date ? " - " + (0, _moment.default)(experience.start_date).format('DD/MM/YYYY') : "", experience.end_date ? ' - ' + (0, _moment.default)(experience.end_date).format('DD/MM/YYYY') : "", experience?.type === 'Stage' ? " (" + experience.type + ") " : undefined), /*#__PURE__*/_react.default.createElement("div", {
        className: "c-experience-card__description",
        dangerouslySetInnerHTML: {
          __html: experience.description
        }
      }));
      return output;
    });
    const status = (0, _getFormStatus.default)(state);
    let output = /*#__PURE__*/_react.default.createElement("div", {
      className: "c-candidate-list-details"
    }, /*#__PURE__*/_react.default.createElement("h1", {
      className: "c-title c-title--center"
    }, state.cv?.title), /*#__PURE__*/_react.default.createElement("div", {
      className: "c-candidate-list-details__first-info"
    }, /*#__PURE__*/_react.default.createElement("p", {
      className: "c-circle-decoration c-circle-decoration--orange"
    }, "Type de contrat : ", component.getSearchedContractLabel(state.cv?.searched_contract_type)), /*#__PURE__*/_react.default.createElement("p", {
      className: "c-circle-decoration c-circle-decoration--blue"
    }, "Domaine professionnel : ", state.cv?._professional_domain?.label), state.cv?.telecommuting ? /*#__PURE__*/_react.default.createElement("p", {
      className: "c-circle-decoration c-circle-decoration--pink"
    }, "T\xE9l\xE9travail : ", state.cv.telecommuting) : undefined), /*#__PURE__*/_react.default.createElement("div", {
      className: "c-candidate-list-details__description",
      dangerouslySetInnerHTML: {
        __html: state.cv?.summary
      }
    }), /*#__PURE__*/_react.default.createElement("div", {
      className: "c-block-infos"
    }, /*#__PURE__*/_react.default.createElement("div", {
      className: "c-block-infos__top c-block-infos__top--candidat"
    }, /*#__PURE__*/_react.default.createElement("button", {
      className: (state.current_info === 0 ? "c-block-infos__top__column--active " : "") + "c-block-infos__top__column c-block-infos__top__column--candidat c-block-infos__top__column--blue",
      onClick: e => component.setState({
        current_info: 0
      })
    }, "Formations"), /*#__PURE__*/_react.default.createElement("button", {
      className: (state.current_info === 1 ? "c-block-infos__top__column--active " : "") + "c-block-infos__top__column c-block-infos__top__column--candidat c-block-infos__top__column--blue",
      onClick: e => component.setState({
        current_info: 1
      })
    }, "Exp\xE9riences"), /*#__PURE__*/_react.default.createElement("button", {
      className: (state.current_info === 2 ? "c-block-infos__top__column--active " : "") + "c-block-infos__top__column c-block-infos__top__column--candidat c-block-infos__top__column--blue",
      onClick: e => component.setState({
        current_info: 2
      })
    }, "Domaines de comp\xE9tences"), /*#__PURE__*/_react.default.createElement("button", {
      className: (state.current_info === 3 ? "c-block-infos__top__column--active " : "") + "c-block-infos__top__column c-block-infos__top__column--candidat c-block-infos__top__column--blue",
      onClick: e => component.setState({
        current_info: 3
      })
    }, "Soft skills"), /*#__PURE__*/_react.default.createElement("button", {
      className: (state.current_info === 4 ? "c-block-infos__top__column--active " : "") + "c-block-infos__top__column c-block-infos__top__column--candidat c-block-infos__top__column--blue",
      onClick: e => component.setState({
        current_info: 4
      })
    }, "Logiciels / Langages informatiques ma\xEEtris\xE9s"), /*#__PURE__*/_react.default.createElement("button", {
      className: (state.current_info === 5 ? "c-block-infos__top__column--active " : "") + "c-block-infos__top__column c-block-infos__top__column--candidat c-block-infos__top__column--blue",
      onClick: e => component.setState({
        current_info: 5
      })
    }, "Langues & Centre d'int\xE9r\xEAt(s)")), /*#__PURE__*/_react.default.createElement("div", {
      className: (state.current_info === 0 ? "c-block-infos__txt--active " : "") + "c-block-infos__txt c-block-infos__txt--blue"
    }, formation_list), /*#__PURE__*/_react.default.createElement("div", {
      className: (state.current_info === 1 ? "c-block-infos__txt--active " : "") + "c-block-infos__txt c-block-infos__txt--blue"
    }, experience_list), /*#__PURE__*/_react.default.createElement("div", {
      className: (state.current_info === 2 ? "c-block-infos__txt--active " : "") + "c-block-infos__txt c-block-infos__txt--blue"
    }, /*#__PURE__*/_react.default.createElement("div", {
      className: "c-candidate-list-details__description",
      dangerouslySetInnerHTML: {
        __html: state.cv?.expertise_field
      }
    })), /*#__PURE__*/_react.default.createElement("div", {
      className: (state.current_info === 3 ? "c-block-infos__txt--active " : "") + "c-block-infos__txt c-block-infos__txt--blue"
    }, /*#__PURE__*/_react.default.createElement("div", {
      className: "c-candidate-list-details__description",
      dangerouslySetInnerHTML: {
        __html: state.cv?.soft_skills
      }
    })), /*#__PURE__*/_react.default.createElement("div", {
      className: (state.current_info === 4 ? "c-block-infos__txt--active " : "") + "c-block-infos__txt c-block-infos__txt--blue"
    }, /*#__PURE__*/_react.default.createElement("div", {
      className: "c-candidate-list-details__description",
      dangerouslySetInnerHTML: {
        __html: state.cv?.software_and_language
      }
    })), /*#__PURE__*/_react.default.createElement("div", {
      className: (state.current_info === 5 ? "c-block-infos__txt--active " : "") + "c-block-infos__txt c-block-infos__txt--blue"
    }, /*#__PURE__*/_react.default.createElement("div", {
      className: "c-candidate-list-details__description",
      dangerouslySetInnerHTML: {
        __html: state.cv?.hobbies
      }
    }), /*#__PURE__*/_react.default.createElement("div", {
      className: "c-candidate-list-details__description",
      dangerouslySetInnerHTML: {
        __html: state.cv?.language
      }
    }))), /*#__PURE__*/_react.default.createElement("button", {
      type: "submit",
      onClick: component.sendInterestNotif,
      className: "c-btn c-btn--blue u-margin-top-20"
    }, "Je suis int\xE9ress\xE9 par ce candidat", loader), status);
    return output;
  }
}
exports.default = CandidateListDetails;
